import {EMPTY, Observable, Subscription} from 'rxjs';
import {catchError} from 'rxjs/operators';

export function dateToStr(date: Date): string | null {
  if (!date) { return null; }
  return JSON.stringify(date);
}

export function strToDate(str: string): Date | null {
  if (!str) { return null; }
  return new Date(JSON.parse(str));
}

export function arrayToStr<T>(array: T[]): string {
  if (!array) { return ''; }
  return JSON.stringify(array);
}

export function strToArray<T>(str: string): T[] {
  if (!str) { return []; }
  return JSON.parse(str) as T[];
}

export function objectToStr<T>(obj: T): string {
  if (!obj) { return ''; }
  return JSON.stringify(obj);
}

export function strToObject<T>(str: string): T {
  if (!str) { return {} as T; }
  return JSON.parse(str);
}

export const DEBOUNCE_TIME = 500;

export function safeUnsub(...subscriptions: Subscription[]) {
  for (const subscription of subscriptions) {
    if (subscription) { subscription.unsubscribe(); }
  }
}

export const logAndReturnEmpty: (err) => Observable<never> = err => {
  console.error(err);
  return EMPTY;
};

export const byOrderIndexField = (a, b) => {
  if (a && b) {
    if (a.orderIndex === b.orderIndex) {
      return 0;
    }
    return a.orderIndex > b.orderIndex ? 1 : -1;
  }
  return -1;
};

export const safeObserve: <T>(observable: Observable<T>, catcher?: (err) => Observable<T>) => Observable<T>
  = <T>(observable: Observable<T>, catcher: (err) => Observable<T> = logAndReturnEmpty) => observable.pipe(catchError(catcher));
